import React, { useEffect, useState } from 'react';
import ReactGridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { usePlan } from '../_providers/PlanProvider';
import Widgets from '../_new_widgets';
import TransactionController from '../controllers/TransactionController';
import Transaction from '../models/Transaction';
import { Widget } from '../models/Widgets';
import WidgetsController from '../controllers/WidgetsController';
import { useModal } from '../_providers/ModalProvider';
import SelectListModal from '../_modals/SelectListModal';

// const widgets = [
//     {
//         position: {x: 0, y: 0},
//         size: Widgets.NextMonthIncome[1],
//         widget: Widgets.NextMonthIncome[0],
//     },
//     {
//         position: {x: 2, y: 0},
//         size: Widgets.NextMonthExpense[1],
//         widget: Widgets.NextMonthExpense[0],
//     },
    
//     {
//         position: {x: 4, y: 0},
//         size: Widgets.NextMonthDelta[1],
//         widget: Widgets.NextMonthDelta[0],
//     },
//     {
//         position: {x: 0, y: 1},
//         size: Widgets.NextMonthImageDelta[1],
//         widget: Widgets.NextMonthImageDelta[0],
//         settings: {
//             goodImage: "https://ae01.alicdn.com/kf/S4544e5fdeb924125a251eb23419cac629.jpg_640x640q90.jpg", 
//             badImage: "https://images.seeklogo.com/logo-png/42/1/angry-stitch-logo-png_seeklogo-427330.png"
//         } 
//     }
// ]

const WidgetPage = () => {
    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const { selectedPlan } = usePlan();
    const width = window.innerWidth - 250;
    const [canEdit, setEdit] = React.useState(false);
    const [widgets, setWidgets] = useState<{[x: string]: Widget}>({});
    const {setModal} = useModal();

    useEffect(() => {
      if(!selectedPlan) {
        setError("No plan selected");
        setLoading(false);
        return;
      }
      Promise.all([
        TransactionController.getTransactions(selectedPlan.uid),
        WidgetsController.getWidgets(selectedPlan.uid)
    ])
        .then(([transactions, widgets]) => {
          setTransactions(transactions);
          setWidgets(widgets.widgets.reduce((acc, widget, index) => {
              acc[index.toString()] = widget;
              return acc;
          }, {} as {[x: string]: Widget}));
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }, [selectedPlan]);

    const addWidget = (widget: string) => {
        const [,size,settings] = Widgets[widget as keyof typeof Widgets];
        const newWidget: Widget = {
            name: widget,
            xPos: 0,
            yPos: 0,
            width: size.w,
            height: size.h
        }
        const w = Object.keys(settings).length != 0 ? {...newWidget, settings} : newWidget;
        const newID = Math.max(...Object.keys(widgets).map((w) => parseInt(w))) + 1;
        const newWidgets = {...widgets, [newID]: w};
        setWidgets(newWidgets);
    }

    const handleEditSave = () => {
        if(!canEdit) {
            setEdit(true);
            return;
        }
        if(selectedPlan == null) {
            setError("No plan selected");
            return;
        }
        WidgetsController.setWidgets(selectedPlan.uid, Object.values(widgets)).then(() => {
            setEdit(false);
        }).catch((error) => {
            setError(error.message);
        });
    }

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    
    return (
        <div style={{paddingBottom: 40}}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h1>{selectedPlan?.name}</h1>
                <div style={{display: "flex", alignItems: "center", gap: 10}}>
                    {canEdit ? <button className='btn' onClick={() => setModal("New Widget", <SelectListModal list={Object.keys(Widgets)} onSelect={(item) => addWidget(item)} />)}><p>New</p><i className="fa-solid fa-plus" /></button> : null}
                    <button className='btn' onClick={() => handleEditSave()}><p>{canEdit ? 'Save' : 'Edit'}</p><i className={ canEdit ? 'fa-solid fa-floppy-disk' : 'fa-solid fa-pencil'} /></button>
                </div>
            </div>
            <ReactGridLayout
                className="layout"
                cols={Math.floor(width / 160)} // Adjust column count based on screen width
                rowHeight={105}
                width={width} // Set width to match screen width
                isDraggable={canEdit}
                isResizable={canEdit}
                onResizeStop={(layout, layoutItem) => {
                    console.log(layout);
                    setWidgets((prev) => {
                        const newWidgets = {...prev};
                        const newSize = layout.find((item) => item.i === layoutItem.i) as any;
                        newWidgets[layoutItem.i] = {
                            ...newWidgets[layoutItem.i],
                            width: newSize.w,
                            height: newSize.h,
                        }
                        return newWidgets;
                    });
                }}
                onDragStop={(layout, layoutItem) => {
                    console.log(layout);
                    setWidgets((prev) => {
                        const newWidgets = {...prev};
                        const newPos = layout.find((item) => item.i === layoutItem.i) as any;
                        newWidgets[layoutItem.i] = {
                            ...newWidgets[layoutItem.i],
                            xPos: newPos.x,
                            yPos: newPos.y,
                        }
                        return newWidgets;
                    });
                }}
            >
                {Object.entries(widgets).map(([key, widget]) => 
                {
                    const [W] = Widgets[widget.name as keyof typeof Widgets];
                    return (
                    <div key={key} data-grid={{x: widget.xPos, y: widget.yPos, w: widget.width, h: widget.height}}>
                        <W transactions={transactions} canEdit={canEdit} settings={widget.settings} onChangeSettings={(newSettings) => setWidgets((prev) => ({...prev, [key]: {...prev[key], settings: newSettings}}))} />
                    </div>
                )})}

            </ReactGridLayout>
        </div>
    );
};

export default WidgetPage;